<h2>{{ 'LICENCE_CHECKING.endorsements' | translateOrFallback:'Endorsements' }}</h2>

<vrm-basic-table [data]="dataSource" [columns]="columns">
  <ng-container matColumnDef="convictionDate">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.convictionDate' | translateOrFallback:'Conviction Date' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.convictionDate }}</td>
  </ng-container>

  <ng-container matColumnDef="offenceDate">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.offenceDate' | translateOrFallback:'Offence Date' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.offenceDate }}</td>
  </ng-container>

  <ng-container matColumnDef="disqualificationExpiryDate">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.disqualificationExpiryDate' | translateOrFallback:'Disqualification End Date' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.disqualificationExpiryDate }}</td>
  </ng-container>

  <ng-container matColumnDef="offenceCode">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.offenceCode' | translateOrFallback:'Offence Code' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.offenceCode }}</td>
  </ng-container>

  <ng-container matColumnDef="points">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.points' | translateOrFallback:'Points' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.points }}</td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORTCOLUMNS.description' | translateOrFallback:'Description' }}</th>
    <td mat-cell *matCellDef="let row">{{ row.description }}</td>
  </ng-container>
</vrm-basic-table>
